import cookie from 'react-cookies';

import { generateAbtTestValue } from '@r1-frontend/shared/helpers/generateAbtTestValue';

export const getProjectClientId = () => cookie.load('abn_test') ?? generateAbtTestValue();

function getKeyStartsWith<K extends string>(keys: string[], prefix: K): `${K}${string}` | null {
    const result = keys.find((key: string) => key.startsWith(prefix));
    return result ? result as `${K}${string}` : null;
}

/**
 * Получение YA clientId из yacounter
 */
const getYmClientId = (): string | undefined => {
    try {
        const yaCounterKey = getKeyStartsWith(Object.keys(window), 'yaCounter');

        if (yaCounterKey) {
            return window[yaCounterKey]?.getClientID();
        }
    } catch {
        return getProjectClientId();
    }
};

export const COOKIE_YM_ID = '_ym_uid';

interface IResultGetAnalyticsIdId {
    analyticsId: string,
}

export const getYmIdValue = (): string => {
    const clientYAId: string | undefined = cookie.load(COOKIE_YM_ID);
    return clientYAId || getYmClientId() || getProjectClientId();
};

export const getYmAnalyticsId = (): IResultGetAnalyticsIdId => {
    return {
        analyticsId: getYmIdValue(),
    };
};

